import 'easy-autocomplete/dist/jquery.easy-autocomplete';
import sidebar from "./sidebar-list";
const expression   = /[ąćęłńóśźż]/gi;
const replacements = {
    'ą': 'a', 'ć': 'c', 'ę': 'e', 'ł': 'l', 'ń': 'n', 'ó': 'o', 'ś': 's', 'ź': 'z', 'ż': 'z',
    'Ą': 'A', 'Ć': 'C', 'Ę': 'E', 'Ł': 'L', 'Ń': 'N', 'Ó': 'O', 'Ś': 'S', 'Ź': 'Z', 'Ż': 'Z'
};
const replacePolishLetters = (text) => {
    return text.replace(expression, (letter) => replacements[letter]);
};


let globalSearchInputValue;

function setGlobalSearchInputValue() {
    globalSearchInputValue = $('.search-popup__input').val();
}

function searchForProducts() {
    $('[data-open-search-popup]').on('click', function () {
        $('.search-popup').addClass('show');
    });
    $('[data-close-search-popup]').on('click', function () {
        $('.search-popup').removeClass('show');
    });

    const options = {
        url: '/wp-content/themes/MTA/data/search_products.json',
        getValue: "searchPhrase",
        list: {
            maxNumberOfElements: 10,
            match: {
                enabled: true,
                method: function (element, phrase) {
                    phrase = replacePolishLetters(phrase.toLocaleLowerCase());
                    const phrases = phrase.split(' ');
                    return phrases.reduce((prev, curr) => {
                        if (!prev) return false;
                        return element.includes(curr);
                    }, true);
                },
            },
            onSelectItemEvent:function() {
                setGlobalSearchInputValue();
                return false;
            },
            onChooseEvent:function() {
                return false;
            },
            onKeyEnterEvent:function() {
                $('.search-popup__input').val(globalSearchInputValue);
                return false;
            },
            onMouseOutEvent:function() {
                setGlobalSearchInputValue();
                return false;
            },
        },
        highlightPhrase: false,
        template: {
            type: "custom",
            method: function (value, item) {
                    return (
                        '<a href="' + item.link + '" class="search__item">' +
                        '<div class="item__image-wrapper">' +
                        '<img src="' + item.image + '" alt="" class="item__image">' +
                        '</div>' +
                        '<h3 class="item__name">' + item.name + '</h3>' +
                        '</a>'
                    );
            }
        }
    };
    $('.search-popup__input').easyAutocomplete(options);
    $('.search-popup__input').on('keydown', function (e) {
        if (e.key === 'Enter' || e.keyCode === 13) {
            $('main').append('<div class="loader-wrapper loader-wrapper--category" style="z-index: 10;"><span class="loader"></span></div>');

            const ajaxData = {
                action: 'make_search_call',
                phrase: $(this).val(),
                original: $(this).val()
            };


            $.post(settings.ajax_url, ajaxData)
                .done((response) => {
                    response = JSON.parse(response);
                    window.location.href = response.redirectLink;
                });
        }
    });
}


export default {
    searchForProducts,
};



// WEBPACK FOOTER //
// ./src/scripts/search.js